/* global Splide */
"use strict";

($dt => {

	$dt.blocks['cta-large-image'] = {

		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const slider = container.querySelector('.splide');
			const slides = container.querySelectorAll('.splide__list .splide__slide');
			if (slides.length > 1) {
				const options = {
					type: 'loop',
					autoplay: true,
					pagination: false,
					interval: 7000,
					arrows: true,
					focus: 'center',
					drag: false,
					breakpoints: {
						767: {
							gap: '0',
							perPage: 1,
						},
						1200: {
							gap: '20px',
							perPage: 2,
						},
						4000: {
							gap: '20px',
							perPage: 3 
						}
					}
				}; 
				new Splide(slider, options).mount();
			} else {
				const options = {
					type: 'loop',
					autoplay: false,
					pagination: false,
					focus: 'center',
					arrows: false,
					drag: false,
					perPage: 1
				};
				new Splide(slider, options).mount();
			}
		}

	};

})(window.d3_wp_themejs);
